const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'
import teras from '@/teras'


class evento{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment

      this.profile = new dbItem({database:'wvpac_abstract_2023',table:'evento'})

      this.profile.event.on('loaded', async () =>{
         console.log("EVENTO LOADED")
         storage.save('evento',this.profile.row.id)      
         await this.init() 
         teras.event.emit('loadedEvento')
         //teras.app.step++
      })

      this._topic = []
      return this
   }

   async getTopic(){
      console.log("CARICATO CON ID "+this.profile.row.id)
      await axios.query('fetchAll',`SELECT * FROM topic WHERE evento=←id ORDER BY peso, nome`,{id: this.profile.row.id},this,'_topic')
      console.log("CARICATO CON ID "+this.profile.row.id)
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }
/*
   async getMateriale(){
      await axios.query('fetchAll',`SELECT * FROM lezione WHERE evento=←id AND materiale=1 ORDER BY peso, tipo, titolo`,{id: this.profile.row.id},this,'_materiale')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async getApprofondimento(){
      await axios.query('fetchAll',`SELECT * FROM approfondimento WHERE evento=→id ORDER BY peso, titolo`,{id: this.profile.row.id},this,'_approfondimento')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async getBibliografia(){
      await axios.query('fetchAll',`SELECT * FROM bibliografia WHERE evento=→id ORDER BY peso, titolo`,{id: this.profile.row.id},this,'_bibliografia')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async getGlossario(){
      await axios.query('fetchAll',`SELECT * FROM glossario WHERE evento=→id ORDER BY peso, vocabolo`,{id: this.profile.row.id},this,'_glossario')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async getLink(){
      await axios.query('fetchAll',`SELECT * FROM link WHERE evento=→id ORDER BY peso, titolo`,{id: this.profile.row.id},this,'_link')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async getAutore(){
      await axios.query('fetchAll',`SELECT * FROM autore WHERE evento=→id  ORDER BY peso, cognome, nome ,affiliazione`,{id: this.profile.row.id},this,'_autore')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async getTutoraggio(){
      await axios.query('fetchAll',`SELECT * FROM tutoraggio WHERE evento=←id AND step>-1 ORDER BY domandail DESC, rispostail DESC`,{id: this.profile.row.id},this,'_tutoraggio')
   }
*/
   async init(){
      console.log("EVENTO CARICATO CON ID "+this.profile.row.id)
      await this.getTopic()
      /*
      await this.getMateriale()
      await this.getApprofondimento()
      await this.getBibliografia()
      await this.getGlossario()
      await this.getLink()
      await this.getAutore()
      await this.getTutoraggio()
      */
      
      return new Promise((resolve, reject) => {
         console.log("EVENTO INIT finito per "+this.profile.row.nome)
         resolve("Fatto")
      })
   }

}
export default new evento
